import { render, staticRenderFns } from "./Newsdetail.vue?vue&type=template&id=179353ae"
import script from "./Newsdetail.vue?vue&type=script&lang=js"
export * from "./Newsdetail.vue?vue&type=script&lang=js"
import style0 from "./Newsdetail.vue?vue&type=style&index=0&id=179353ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports